import React, { useState } from 'react';
import _ from 'lodash';
import Button from 'components/Button';
import LoginDialog from 'pages/home/Header/LoginDialog';
import SignUpDialog from 'pages/home/Header/SignUpDialog';
import ForgotPasswordDialog from 'pages/home/Header/ForgotPassword';
import logo from 'assets/images/logo.png';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import {
  Container,
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLink,
  RightMenu,
  LeftMenu,
} from 'styles/pages/home/header';

const Header = ({
  loginDialog,
  signUpDialog,
  forgotPasswordDialog,
  toggleLoginDialog,
  toggleSignUpDialog,
  toggleForgotPasswordDialog,
}) => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  return (
    <Container>
      <Nav>
        <NavbarContainer>
          <LeftMenu>
            <NavLogo>
              <img src={logo} alt='logo' />
            </NavLogo>
            <MobileIcon onClick={handleClick}>
              {click ? <CloseIcon /> : <MenuIcon />}
            </MobileIcon>
            {/*<NavMenu onClick={handleClick} click={click}>
              <NavItem>
                <NavLink href='#products-pricing'>Products & Pricing</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='#whats-new'>What's new</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='#how-it-works'>How it Works</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='#key-features'>Key Features</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='#product-bundling'>Product Bundling</NavLink>
              </NavItem>
            </NavMenu>*/}
          </LeftMenu>
          <RightMenu>
            <Button
              title='Login'
              onClick={() =>
                _.isFunction(toggleLoginDialog) && toggleLoginDialog()
              }
            />
            <Button
              title='Sign Up'
              onClick={() =>
                _.isFunction(toggleSignUpDialog) && toggleSignUpDialog()
              }
            />
          </RightMenu>
        </NavbarContainer>
      </Nav>

      {loginDialog && (
        <LoginDialog
          open={loginDialog}
          onClose={() => toggleLoginDialog()}
          showSignUpModal={() => {
            toggleLoginDialog();
            toggleSignUpDialog();
          }}
          forgotPasswordDialog={() => {
            toggleLoginDialog();
            toggleForgotPasswordDialog();
          }}
        />
      )}
      {signUpDialog && (
        <SignUpDialog
          open={signUpDialog}
          onClose={() => toggleSignUpDialog()}
          showLoginModal={() => {
            toggleSignUpDialog();
            toggleLoginDialog();
          }}
        />
      )}

      {forgotPasswordDialog && (
        <ForgotPasswordDialog
          open={forgotPasswordDialog}
          onClose={() => toggleForgotPasswordDialog()}
        />
      )}
    </Container>
  );
};

export default Header;
